import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN Modal Content variants using HEN Design System tokens.
 * Controls the maximum width of the modal dialog.
 */
export const modalContentVariants = cva('', {
  variants: {
    size: {
      sm: 'max-w-sm',
      md: 'max-w-lg',
      lg: 'max-w-2xl',
      xl: 'max-w-4xl',
      full: 'max-w-[calc(100vw-2rem)]',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export type ModalContentVariantProps = VariantProps<
  typeof modalContentVariants
>;
